import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { Icon } from '../../Defaults/Defaults';
import { FlexRowCenter, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import * as arrowSrc from '../../../../assets/heliumking/arrow-down.svg';

interface Props {
  id?: string;
  name?: string;
  label?: string;
  value: string | number | undefined;
  maxWidth?: number;
  marginBottom?: number;
  options: Array<{
    name: string;
    value: string;
  }>;
  autoComplete?: string;
  defaultValue?: {
    name: string;
    value: string | undefined | number;
  };
  onChange: (e: any) => void;
  onBlur?: () => void;
}

function Select({
  name = 'select',
  options,
  value,
  onChange,
  maxWidth = 320,
  marginBottom = 0,
  id,
  label,
  onBlur,
  defaultValue,
  autoComplete = 'off',
}: Props) {
  return (
    <Wrapper marginBottom={marginBottom} maxWidth={maxWidth}>
      {label && <SelectLabel label={label}>{label}</SelectLabel>}
      {false && (
        <DropdownIcon>
          <Icon src={'/images/arrow_triangle.svg'} />
        </DropdownIcon>
      )}
      <StyledSelect
        id={id ? id : ''}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete}
      >
        {defaultValue && (
          <option value={defaultValue!.value}>{defaultValue!.name}</option>
        )}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </StyledSelect>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ maxWidth: number; marginBottom: number }>`
  width: 100%;
  color: #aaaaaa;
  position: relative;
  max-width: ${({ maxWidth }) => rem(maxWidth)};
  margin-right: ${rem(32)};
  margin-bottom: ${({ marginBottom }) => rem(marginBottom)};

  &:focus-within {
    color: ${props => props.theme.colors.btnPrimary};
  }

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    margin-bottom: ${rem(32)};
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
  `}
`;

const SelectLabel: any = styled(TextP)`
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(20)};
  margin-bottom: ${rem(2)};
`;

const DropdownIcon = styled(FlexRowCenter)`
  width: ${rem(8)};
  height: ${rem(4)};
  position: absolute;
  right: ${rem(16)};
  bottom: ${rem(20)};
`;

const StyledSelect = styled.select`
  width: 100%;
  cursor: pointer;
  height: ${rem(48)};
  background: transparent;
  border: 2px solid rgb(234, 234, 234);
  border-radius: ${rem(8)};
  color: rgb(51, 51, 51);
  font-size: ${rem(14)};
  padding: ${rem(8)} ${rem(32)} ${rem(8)} ${rem(16)};
  appearance: none;
  display: flex;
  align-items: center;
  font-family: 'Open Sans, sans-serif';

  background-image: ${`url(${arrowSrc.toString()})`};
  background-position: 95% 50%;
  background-size: 12px 7px;
  background-repeat: no-repeat;

  &:focus {
    border-color: rgb(126, 206, 210);
    outline: none;
  }
`;

export { Select };
